import React, { Component } from 'react';
import { Route, Routes } from 'react-router-dom';
import PaymentPage from './components/PaymentPage';
import ThankYouPage from './components/ThankYouPage';
import './index.css';

export default class App extends Component {
  static displayName = App.name;

  render() {
    return (
      <Routes>
        <Route path="/" element={<NotFoundPage />} />
        
        <Route path="/ThankYou" element={<ThankYouPage />} />
        <Route path="/:friendlyId" element={<PaymentPage />} />
        
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    );
  }
}
function NotFoundPage() {
  return (
      <div className="max-w-4xl mx-auto p-4 bg-gray-50 p-5">
          <div className="bg-white p-8 rounded shadow-sm text-center m-5 p-5">
              <img
                  src="/images/cfm_logo_white.png"
                  alt="CFM Logo"
                  className="mb-4 mx-auto block"
              />
              <h2 className="text-xl font-bold mb-2">Payment Link Not Found!</h2>
              <p className="text-gray-700 mb-4">
                  We couldn't find the payment information you're looking for.
                  Please check the URL and try again.
              </p>
              <p className="text-sm text-gray-500 mt-4">
                  If you believe this is an error, please contact customer support.
              </p>
          </div>
      </div>
  );
}
